export const GoogleAnalyticsEvent = (...args: any[]) => window.gtag(...args);

declare global {
  interface Window {
    gtag: any;
  }
}
